import { EditorUtils } from '../util/editor-utils.js';
import 'vue';
import '@ssml-editor/core';
import '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import '../_virtual/lodash.js';
import { Warning } from '@ssml-editor/base';
import { D as DOMEditor } from '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';

class MenuBaseService {
  editor;
  constructor(editor) {
    this.editor = editor;
  }
  getText() {
    const { selection } = this.editor;
    if (selection) {
      return EditorUtils.getText(this.editor, selection);
    } else {
      return "";
    }
  }
  isDisabled() {
    const { selection } = this.editor;
    if (!selection) {
      DOMEditor.focus(this.editor);
      throw new Warning("未选中编辑器");
    }
    return false;
  }
}

export { MenuBaseService };
//# sourceMappingURL=menu-base-service.js.map
